<template>
    <div>
        <NuxtLink v-if="parentPage" :to="`/${parentPage.handle}`">            
            <UiRippleButton v-motion-pop class="my-16 brown">
                Back to {{parentPage.title}}
            </UiRippleButton>   
        </NuxtLink>     
    </div>
</template>
<script setup>
import { usePageStore } from "@/stores/pageStore";
const pageStore = usePageStore();
 const props = defineProps({
    pageId: {
        type: String,
        required: true        
    }});

    import { onMounted } from 'vue';
    
    const parentPage = ref(null);

    onMounted(async () => {
        let pageId = props.pageId.replace("OnlineStorePage", "Page");               
        parentPage.value = await pageStore.fetchPageByID(pageId);
        
    });
    
</script>